module.exports = __webpack_public_path__ + "static/media/announcement.e94dacd4.png";